import * as ICriminalRecordDeclarationVmInstance from "../models/shared/ICriminalRecordDeclarationVm"
import IAction from "../store/IAction"
import ICriminalRecordDeclarationVm from "../models/shared/ICriminalRecordDeclarationVm"
import { CriminalRecordDeclarationStatus } from "../models/enums/CriminalRecordDeclarationStatus"
import IDeclarationOfficeVm from "../models/shared/IDeclarationOfficeVm"

const UPDATE_CRIMINAL_RECORD_DECLARATION_STATUS = "BAT2/criminalRecordDeclaration/UPDATE_CRIMINAL_RECORD_DECLARATION_STATUS"
const UPDATE_CRIMINAL_RECORD_DECLARATION_DATE = "BAT2/criminalRecordDeclaration/UPDATE_CRIMINAL_RECORD_DECLARATION_DATE"
const UPDATE_CRIMINAL_RECORD_DECLARATION_JOURNAL_NUMBER = "BAT2/criminalRecordDeclaration/UPDATE_CRIMINAL_RECORD_DECLARATION_JOURNAL_NUMBER"
const UPDATE_CRIMINAL_RECORD_DECLARATION_DECLARATION_OFFICE = "BAT2/criminalRecordDeclaration/UPDATE_CRIMINAL_RECORD_DECLARATION_DECLARATION_OFFICE"

export default function criminalRecordDeclarationReducer(state: ICriminalRecordDeclarationVm = ICriminalRecordDeclarationVmInstance.empty(), action: IAction): ICriminalRecordDeclarationVm {
    if (state === null || state === undefined) {
        return state
    }
    switch (action.type) {
        case UPDATE_CRIMINAL_RECORD_DECLARATION_STATUS:
            return { ...state, status: action.payload }
        case UPDATE_CRIMINAL_RECORD_DECLARATION_DATE:
            return { ...state, date: action.payload }
        case UPDATE_CRIMINAL_RECORD_DECLARATION_JOURNAL_NUMBER:
            return { ...state, journalNumber: action.payload }
        case UPDATE_CRIMINAL_RECORD_DECLARATION_DECLARATION_OFFICE:
            return { ...state, declarationOffice: action.payload }
        default:
            return state
    }
}

export function updateCriminalRecordDeclarationStatus(value: CriminalRecordDeclarationStatus, applicationId: string) {
    return { type: UPDATE_CRIMINAL_RECORD_DECLARATION_STATUS, payload: value, id: applicationId }
}
export function updateCriminalRecordDeclarationDate(value: string, applicationId: string) {
    return { type: UPDATE_CRIMINAL_RECORD_DECLARATION_DATE, payload: value, id: applicationId }
}
export function updateCriminalRecordDeclarationJournalNumber(value: string, applicationId: string) {
    return { type: UPDATE_CRIMINAL_RECORD_DECLARATION_JOURNAL_NUMBER, payload: value, id: applicationId }
}
export function updateCriminalRecordDeclarationDeclarationOffice(value: IDeclarationOfficeVm, applicationId: string) {
    return { type: UPDATE_CRIMINAL_RECORD_DECLARATION_DECLARATION_OFFICE, payload: value, id: applicationId }
}